import { render, staticRenderFns } from "./InstanceEditLegal.vue?vue&type=template&id=8fcc080a&scoped=true&"
import script from "./InstanceEditLegal.vue?vue&type=script&lang=js&"
export * from "./InstanceEditLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcc080a",
  null
  
)

export default component.exports